export default __webpack_public_path__ + "c8282057bd1e12254c6ff03ff12bc436.svg";